exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3ZWpD3mGB-bs9yNhrqNc4L{height:550px;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #b3b3b3;border-radius:5px}\n", ""]);

// Exports
exports.locals = {
	"TRouteMapBlock": "_3ZWpD3mGB-bs9yNhrqNc4L"
};